import { useContext } from "react";
import { Outlet } from "react-router-dom";
import { HouseContext } from "../../context/HouseContext";
import LoadingState from "./LoadingState";

// Wraps the propiedades routes. Shows the spinner only on the first load.
function PropertiesLoadingGuard() {
  const { initialLoaded } = useContext(HouseContext);
  if (!initialLoaded) return <LoadingState message="Cargando propiedades..." />;
  return <Outlet />;
}

export default PropertiesLoadingGuard;
